import { render, staticRenderFns } from "./ProductTypeDialogue.vue?vue&type=template&id=aaab3bca&"
import script from "./ProductTypeDialogue.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeDialogue.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports